import { useEffect } from "react";
import { Link, useLocation } from "wouter";
import { ArrowLeft, Globe2, ShieldCheck } from "lucide-react";
import { useAuth } from "../lib/auth";
import { JobseekerDiscoveryControl } from "../components/JobseekerDiscoveryControl";

export default function AccountProfilePrivacy() {
  const { user, loading } = useAuth();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [loading, user, navigate]);

  if (loading) {
    return <div className="container-x py-20 text-center text-mut">Loading profile access…</div>;
  }
  if (!user) return null;

  return (
    <div className="container-x py-6 max-w-2xl">
      <Link href="/settings" className="inline-flex items-center gap-2 text-sm font-semibold text-mut hover:text-navy mb-5">
        <ArrowLeft className="w-4 h-4" /> Back to settings
      </Link>

      <div className="flex items-start gap-3 mb-2">
        <div className="w-11 h-11 rounded-full bg-navy text-white grid place-items-center shrink-0"><Globe2 className="w-5 h-5" /></div>
        <div>
          <h1 className="text-2xl font-extrabold text-navy">Public profile access</h1>
          <p className="text-sm text-mut mt-1">Your member profile remains reachable by link and through relevant marketplace contexts.</p>
        </div>
      </div>

      <section className="card p-5 mt-6" aria-labelledby="profile-access-heading">
        <h2 id="profile-access-heading" className="font-bold text-navy">Your public profile</h2>
        <p className="text-sm text-mut mt-2">
          Your profile link is <span className="font-mono text-xs">/u/{user.id}</span>. Jobseeker directory visibility is a separate preference; turning off Jobseeker discovery does not hide this profile.
        </p>

        <div className="mt-5 pt-5 border-t border-line space-y-3 text-sm">
          <div className="flex gap-3"><Globe2 className="w-4 h-4 text-brand-green shrink-0 mt-0.5" /><p><span className="font-semibold text-navy">Profile link:</span> anyone with your link can open your public member profile.</p></div>
          <div className="flex gap-3"><ShieldCheck className="w-4 h-4 text-brand-green shrink-0 mt-0.5" /><p><span className="font-semibold text-navy">Jobseeker discovery:</span> this separate preference controls whether you appear in Jobseeker listings and search.</p></div>
        </div>

        <Link href={`/u/${user.id}?view=public`} className="btn-outline mt-5">Open your public profile</Link>
      </section>
      <section className="card p-5 mt-6" aria-labelledby="jobseeker-heading">
        <h2 id="jobseeker-heading" className="font-bold text-navy">Jobseeker discovery</h2>
        <JobseekerDiscoveryControl userId={user.id} />
      </section>
    </div>
  );
}
